var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useTaroHoverableEvents from '../_util/hooks/useTaroHoverableEvents';
const Button = (_a, ref) => {
    var { size = 'default', type = 'default', plain = false, formType = 'buttonclick', disabled = false, loading = false, children } = _a, rest = __rest(_a, ["size", "type", "plain", "formType", "disabled", "loading", "children"]);
    const _b = useTaroHoverableEvents(rest), { className } = _b, props = __rest(_b, ["className"]);
    return (_jsxs("button", Object.assign({ ref: ref, className: classNames('weui-btn', {
            'weui-btn_mini': size === 'mini',
            'weui-btn_primary': type === 'primary' && !plain,
            'weui-btn_default': type === 'default' && !plain,
            'weui-btn_warn': type === 'warn',
            'weui-btn_plain-primary': type === 'primary' && plain,
            'weui-btn_plain-default': type === 'default' && plain,
            'weui-btn_disabled': disabled && !plain,
            'weui-btn_plain-disabled': disabled && plain
        }, className), type: formType !== 'buttonclick' ? formType : undefined }, props, { children: [loading && _jsx("i", { className: 'weui-loading' }), children] })));
};
export default forwardRef(Button);
